import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class YearOfIncorporationCriteria extends FilterCriteria {
  public override title = 'Year of Incorporation';
  public override type: FilterTypes = FilterTypes.YearOfIncorporation;
  onAndAfter: number = null;
  upToAndIncluding: number = null;
  includeYearNotKnown: boolean = null;

  public override validate(): boolean {
    this.onAndAfter = isNaN(this.onAndAfter) ? null : this.onAndAfter;
    this.upToAndIncluding = isNaN(this.upToAndIncluding) ? null : this.upToAndIncluding;

    if (this.onAndAfter == null && this.upToAndIncluding == null) {
      return false;
    }
    if (this.onAndAfter && this.upToAndIncluding && this.onAndAfter > this.upToAndIncluding) {
      return false;
    }
    return true;
  }

  public override toString(): string {
    const text = [];
    if (this.onAndAfter) {
      text.push(`From: ${this.onAndAfter}`);
    }
    if (this.upToAndIncluding) {
      text.push(`To: ${this.upToAndIncluding}`);
    }
    if (this.includeYearNotKnown) {
      text.push('include companies for which the year of incorporation is not known');
    }
    return text.join(', ');
  }
}
